<!-- Main Container -->
<div class="main-container">
  <!-- Search Form and Results (kept in DOM; hidden when form tabs visible) -->
  <div [hidden]="showFormTabs">
    <mat-card appearance="outlined">
      <mat-card-title style="margin: 15px;">Search Residents</mat-card-title>
      <mat-card-content>
        <div class="search-container">
          <form [formGroup]="searchForm" (ngSubmit)="onUserSearch()">
            <div class="search-section">
              <mat-form-field appearance="outline">
                <mat-label>Resident Name</mat-label>
                <input matInput formControlName="residentName" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input matInput formControlName="mobileNumber" maxlength="10" (input)="onInput($event)" />
                <mat-error *ngIf="searchForm.get('mobileNumber')?.hasError('pattern')">
                  Please enter a valid 10-digit mobile number.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" />
                <mat-error *ngIf="searchForm.get('email')?.hasError('email')">
                  Please enter a valid email address.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Area Name</mat-label>
                <mat-select formControlName="areaId">
                  <mat-option *ngFor="let area of areas" [value]="area.code">{{ area.value }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Block Number</mat-label>
                <input matInput formControlName="blockNumber" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Quarter Number</mat-label>
                <input matInput formControlName="qtrNumber" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Location Name</mat-label>
                <input matInput formControlName="locatioName" />
              </mat-form-field>
            </div>
            <div class="buttons">
              <button mat-flat-button color="primary" type="submit">
                <mat-icon>search</mat-icon>
                Search
              </button>
              <button mat-stroked-button color="warn" type="button" (click)="onReset()">Reset</button>
              <button mat-flat-button color="primary" type="button" (click)="onCreateNewUser()">
                <mat-icon>person_add</mat-icon>
                Create New User
              </button>
            </div>
          </form>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-title style="margin: 15px;">Residents List</mat-card-title>
      <mat-card-content>
        <div class="table-container">
          <div *ngIf="isLoading" class="loading-container">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>
          <div *ngIf="dataSource.data.length > 0; else noLocationsTemplate">
            <table mat-table [dataSource]="dataSource" class="mat-table" *ngIf="!isLoading">
    
              <!-- Column Definitions -->
              <ng-container matColumnDef="residentType">
                <th mat-header-cell *matHeaderCellDef> Resident Type </th>
                <td mat-cell *matCellDef="let element">
                  {{ getResidentTypeLookUps(element.residentType) | titlecase }}
                </td>
              </ng-container>
    
              <ng-container matColumnDef="residentName">
                <th mat-header-cell *matHeaderCellDef> Resident Name </th>
                <td mat-cell *matCellDef="let element">
                  {{element.residentFirstName}} {{element.residentLastName}}
                </td>
              </ng-container>
    
              <ng-container matColumnDef="mobileNumber">
                <th mat-header-cell *matHeaderCellDef> Mobile Number </th>
                <td mat-cell *matCellDef="let element"> {{element.mobileNumber}} </td>
              </ng-container>
    
              <ng-container matColumnDef="emailAddress">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let element"> {{element.emailAddress}} </td>
              </ng-container>
    
              <ng-container matColumnDef="locationName">
                <th mat-header-cell *matHeaderCellDef> Location </th>
                <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="element?.locationAllocationList?.length > 0; else noLocation">
                    {{ element.locationAllocationList[0]?.locationCode || element.locationAllocationList[0]?.locationName }}
                  </ng-container>
                  <span *ngIf="element?.areaName; else noArea"> - {{ element.areaName }}</span>
                  <ng-template #noArea></ng-template>
                  <ng-template #noLocation>Not assigned</ng-template>
                </td>
              </ng-container>
    
              <ng-container matColumnDef="userName">
                <th mat-header-cell *matHeaderCellDef> User Name </th>
                <td mat-cell *matCellDef="let element"> {{element.userName}} </td>
              </ng-container>
    
              <ng-container matColumnDef="accountActive">
                <th mat-header-cell *matHeaderCellDef> Account Active </th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">
                  <mat-icon [ngClass]="element.loginEnabled === 'Y' ? 'icon-green' : 'icon-red'">
                    {{ element.loginEnabled === 'Y' ? 'check_circle' : 'cancel' }}
                  </mat-icon>
                </td>
              </ng-container>
    
              <ng-container matColumnDef="view">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="basicInfo(element, 'basicInfo')">
                      <mat-icon>edit</mat-icon>
                      <span>Edit Basic Info</span>
                    </button>
                    <button mat-menu-item (click)="basicInfo(element, 'manageLocation')">
                      <mat-icon>location_on</mat-icon>
                      <span>Manage Location</span>
                    </button>
                    <button mat-menu-item (click)="basicInfo(element, 'manageLogin')">
                      <mat-icon>login</mat-icon>
                      <span>Manage Login</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
    
              <tr mat-header-row *matHeaderRowDef="displayedSearchColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedSearchColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="8">No data matching the filter</td>
              </tr>
            </table>
          </div>
          <mat-paginator [length]="searchLength" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[5, 10, 20, 50]"
            (page)="onPageChange($event)">
          </mat-paginator>
    
        </div>
        <ng-template #noLocationsTemplate>
          <div class="no-data-message">
            <mat-icon>home</mat-icon>
            <p>No locations found for the selected area.</p>
          </div>
        </ng-template>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Resident Form Card (kept in DOM; hidden when search/list visible) -->
  <mat-card appearance="outlined" [hidden]="!showFormTabs">
    <mat-card-title style="margin: 15px;">{{ preFilled ? 'Edit Resident' : 'Create New Resident' }}</mat-card-title>
    <mat-card-content>
      <mat-tab-group #tabGroup [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">

        <!-- Basic Info Tab -->
        <mat-tab label="Basic Info" style="background-color: red;">
          <form [formGroup]="residentForm" (ngSubmit)="onSubmit()">
            <div>
              <h6 style="margin-top: 15px;">Basic Information</h6>
              <div class="form-grid">
                <mat-form-field appearance="outline" style="margin: 15px;">
                  <mat-label>Resident Type</mat-label>
                  <mat-select formControlName="residentType" (selectionChange)="onResidentTypeChange($event)" required>
                    <mat-option *ngFor="let type of residentTypes" [value]="type.lookupCode">{{ type.lookupValue
                      }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="residentForm.get('residentType')?.hasError('required')">
                    Resident type is required.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="margin: 15px;">
                  <mat-label>Resident Priority</mat-label>
                  <mat-select formControlName="residentPriority" required>
                    <mat-option *ngFor="let priority of residentPriorities" [value]="priority.lookupCode">
                      {{ priority.lookupValue }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="residentForm.get('residentPriority')?.hasError('required')">
                    Resident priority is required.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="margin: 15px;">
                  <mat-label>First Name</mat-label>
                  <input matInput formControlName="firstName" required (keydown)="onRemoveSpl($event, 'firstName')">
                  <mat-error *ngIf="residentForm.get('firstName')?.hasError('required')">
                    First name is required.
                  </mat-error>
                  <mat-error *ngIf="residentForm.get('firstName')?.hasError('minlength')">
                    First name must be at least 2 characters.
                  </mat-error>
                  <mat-error *ngIf="residentForm.get('firstName')?.hasError('invalidChars')">
                    First name can only contain letters and spaces.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="margin: 15px;">
                  <mat-label>Last Name</mat-label>
                  <input matInput formControlName="lastName" (keydown)="onRemoveSpl($event, 'lastName')">
                  <mat-error *ngIf="residentForm.get('lastName')?.hasError('invalidChars')">
                    Last name can only contain letters and spaces.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="margin: 15px;">
                  <mat-label>Rank</mat-label>
                  <input matInput formControlName="rank" (keydown)="onRemoveSpl($event, 'rank')">
                  <mat-error *ngIf="residentForm.get('rank')?.hasError('invalidChars')">
                    Rank can only contain letters and spaces.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="margin: 15px;">
                  <mat-label>Mobile Number</mat-label>
                  <input matInput formControlName="mobileNo" type="text" maxlength="10" (input)="onInput($event)"
                    placeholder="e.g., 9876543210" required>
                  <mat-error *ngIf="residentForm.get('mobileNo')?.hasError('required')">Mobile number is
                    required.</mat-error>
                  <mat-error *ngIf="residentForm.get('mobileNo')?.hasError('pattern')">
                    Please enter a valid 10-digit mobile number.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="margin: 15px;">
                  <mat-label>Alternate Mobile Number</mat-label>
                  <input matInput formControlName="altermobileNo" type="text" maxlength="10" (input)="onInput($event)"
                    placeholder="e.g., 9876543210">
                  <mat-error *ngIf="residentForm.get('altermobileNo')?.hasError('pattern')">
                    Please enter a valid 10-digit mobile number.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="margin: 15px;">
                  <mat-label>Email Address</mat-label>
                  <input matInput formControlName="emailAddress" type="email" placeholder="name@example.com" required>
                  <mat-error *ngIf="residentForm.get('emailAddress')?.hasError('required')">Email is
                    required.</mat-error>
                  <mat-error *ngIf="residentForm.get('emailAddress')?.hasError('pattern')">
                    Please enter a valid email address.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="communication-preferences">
              <h6>Communication Preferences</h6>
              <mat-checkbox formControlName="allowEmail" color="primary">Allow Email Communication</mat-checkbox>
              <mat-checkbox formControlName="allowSMS" color="primary">Allow SMS Communication</mat-checkbox>
            </div>
          </form>
        </mat-tab>

        <!-- Manage Location Tab -->
        <mat-tab label="Manage Location">
          <div>
            <h6 style="margin-top: 15px;">Assigned Locations</h6>
            <div style="text-align: right;">
              <button mat-flat-button color="primary" (click)="openLocationPopup()">
                <mat-icon>search</mat-icon> Find and Add Location
              </button>
            </div>
            <div class="table-container">
              <table mat-table [dataSource]="assignedLocations" class="mat-table">
                <ng-container matColumnDef="areaName">
                  <th mat-header-cell *matHeaderCellDef> Area Name </th>
                  <td mat-cell *matCellDef="let element"> {{element.areaName}} </td>
                </ng-container>
                <ng-container matColumnDef="QuarterNo">
                  <th mat-header-cell *matHeaderCellDef> Quarter No </th>
                  <td mat-cell *matCellDef="let element"> {{element.quarterNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="blockNumber">
                  <th mat-header-cell *matHeaderCellDef> Block Number </th>
                  <td mat-cell *matCellDef="let element"> {{element.blockNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="locationName">
                  <th mat-header-cell *matHeaderCellDef> Location Name </th>
                  <td mat-cell *matCellDef="let element"> {{element.locationName}} </td>
                </ng-container>
                <ng-container matColumnDef="locationAssignedTo">
                  <th mat-header-cell *matHeaderCellDef> Location Assigned to </th>
                  <td mat-cell *matCellDef="let element"> {{element.locationAssignedTo}} </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> Actions </th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="warn" (click)="removeLocation(element.id)"
                      *ngIf="element.status !== 'Deleted'">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let element" [ngClass]="{
                    'status-assigned': element.status === 'Assigned',
                    'status-deleted': element.status === 'Deleted',
                    'status-new': element.status === 'Newly Added'
                  }">
                    {{ element.status }}
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="7">No locations assigned yet.</td>
                </tr>
              </table>
            </div>
          </div>
        </mat-tab>

        <!-- Manage Login Tab -->
        <mat-tab label="Manage Login">
          <div>
            <h6 style="margin-top: 15px;">User Login Details</h6>
            <form [formGroup]="loginForm" class="form-grid">
              <mat-form-field appearance="outline" style="display:inline-block; width:48%; margin-right:4%;">
                <mat-label>User Name</mat-label>
                <input matInput formControlName="userName" required>
                <mat-error *ngIf="loginForm.get('userName')?.hasError('required') && loginForm.get('userName')?.touched">
                  User name is required.
                </mat-error>
                <mat-error *ngIf="loginForm.get('userName')?.hasError('minlength')">
                  Must be at least 5 characters.
                </mat-error>
                <mat-error *ngIf="loginForm.get('userName')?.hasError('maxlength')">
                  Cannot exceed 12 characters.
                </mat-error>
                <mat-error *ngIf="loginForm.get('userName')?.hasError('pattern')">
                  Username can only contain letters, numbers, &#64;, ., or _.
                </mat-error>
                 <mat-error *ngIf="loginForm.get('userName')?.hasError('usernameExists')">
                   Username already exists. Please choose a different username.
                 </mat-error>
              </mat-form-field>
        
              <mat-form-field appearance="outline" style="display:inline-block; width:48%;">
                <mat-label>Password</mat-label>
                <input matInput formControlName="password" [type]="hideCurrentPassword ? 'password' : 'text'" spellcheck="false"
                  (copy)="false" (cut)="false" (paste)="false" autocorrect="off">
                <button mat-icon-button matSuffix (click)="hideCurrentPassword = !hideCurrentPassword">
                  <mat-icon>{{ hideCurrentPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error *ngIf="loginForm.get('password')?.hasError('minlength')">
                  Password must be at least 8 characters.
                </mat-error>
                <mat-error *ngIf="loginForm.get('password')?.hasError('maxlength')">
                  Password cannot exceed 12 characters.
                </mat-error>
                <mat-error *ngIf="loginForm.get('password')?.hasError('pattern')">
                  Must include uppercase, lowercase, number, and special character.
                </mat-error>
                  <mat-error *ngIf="loginForm.get('password')?.hasError('backendError')">
                    {{ loginForm.get('password')?.getError('backendError') }}
                  </mat-error>
              </mat-form-field>
        
              <mat-checkbox formControlName="loginAccountEnabled" color="primary" style="display:block; margin-top:16px;">
                Login Account Enabled
              </mat-checkbox>
            </form>
        
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
    <mat-card-actions align="end" style="margin: 15px;">
      <button style="margin-right: 10px;" mat-flat-button color="primary" (click)="checkUsernameExists()">
        <mat-icon>save</mat-icon> {{ preFilled ? 'Update' : 'Save' }}
      </button>
      <button mat-stroked-button color="warn" (click)="onCancel()">Cancel</button>
    </mat-card-actions>
  </mat-card>
</div>
